var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearchLoupe = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.571 2.084C25.331 2.084 30 6.753 30 12.513c0 5.76-4.669 10.428-10.429 10.428-5.76 0-10.428-4.669-10.428-10.428 0-5.76 4.669-10.429 10.428-10.429ZM32 12.513C32 5.648 26.436.084 19.571.084c-6.864 0-12.428 5.564-12.428 12.429 0 6.864 5.564 12.428 12.428 12.428C26.435 24.941 32 19.377 32 12.513Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m.293 30.377 10-10 1.414 1.414-10 10-1.414-1.414Z"
})));
export default SvgSearchLoupe;